export default {
  urls: {
    FEEDBACK: "/feedbacks",
  },
};
